import { render, staticRenderFns } from "./ContactEdit.vue?vue&type=template&id=cb1fa1b8&scoped=true"
import script from "./ContactEdit.vue?vue&type=script&lang=js"
export * from "./ContactEdit.vue?vue&type=script&lang=js"
import style0 from "./ContactEdit.vue?vue&type=style&index=0&id=cb1fa1b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb1fa1b8",
  null
  
)

export default component.exports